import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { InformationsColumnBlockConfig } from '@front-platform/content-builder';
import { informationsColumnBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
export interface InformationsColumnBlockRuntimeConfig {
  'columns'?: unknown[];
}

export type InformationsColumnBlockConfigInput = Partial<
  Omit<InformationsColumnBlockConfig, keyof InformationsColumnBlockRuntimeConfig> &
    InformationsColumnBlockRuntimeConfig
>;
export type InformationsColumnBlockResolvedConfig = Omit<
  InformationsColumnBlockConfig,
  keyof InformationsColumnBlockRuntimeConfig
> &
  Partial<InformationsColumnBlockRuntimeConfig>;
export interface InformationsColumnBlockContract extends ConfigComponentContract<
  InformationsColumnBlockConfigInput,
  InformationsColumnBlockResolvedConfig
> {}

@Component({
  selector: 'app-informations-column-block',
  templateUrl: './informations-column-block.component.html',
  standalone: false,
})
export class InformationsColumnBlockComponent implements InformationsColumnBlockContract {
  readonly config = input<InformationsColumnBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    InformationsColumnBlockConfig,
    InformationsColumnBlockRuntimeConfig
  >(informationsColumnBlockResolveConfig, () => ({ config: this.config() }));
  get icon(): string {
    return this.resolvedConfig()['icon'] as unknown as string;
  }
  get title(): string {
    return this.resolvedConfig()['title'] as unknown as string;
  }
  get columns(): unknown[] {
    return this.resolvedConfig()['columns'] as unknown as unknown[];
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(InformationsColumnBlockComponent, {
  'keyAliases': {},
});
